export const COOKIE_CONSENT_STORAGE_KEY = 'lmw_cookie_consent'
export const COOKIE_CONSENT_EVENT = 'lmw-cookie-consent-changed'

export function getCookieConsentChoice() {
  try {
    return localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY)
  } catch (error) {
    return null
  }
}

export function hasTrackingConsent() {
  return true
}

export function setCookieConsentChoice(choice) {
  try {
    localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, choice)
  } catch (error) {
    return
  }

  window.dispatchEvent(
    new CustomEvent(COOKIE_CONSENT_EVENT, {
      detail: { choice },
    })
  )
}

export function clearCookieConsentChoice() {
  try {
    localStorage.removeItem(COOKIE_CONSENT_STORAGE_KEY)
  } catch (error) {
    return
  }

  window.dispatchEvent(
    new CustomEvent(COOKIE_CONSENT_EVENT, {
      detail: { choice: null },
    })
  )
}
